import type { ReactNode } from "react";
import { Paper, PaperProps } from "@mantine/core";

export interface BorderedCardProps extends PaperProps {
  children?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  /**
   * Border color. Omit to use default (var(--mantine-color-gray-3)).
   * Apps can pass theme.other.semanticColors.borderSubtle for token alignment.
   */
  borderColor?: string;
}

/**
 * A Paper component with consistent border styling.
 * Token-agnostic: pass optional borderColor from theme.other.semanticColors.borderSubtle for app alignment.
 */
export function BorderedCard({
  children,
  style,
  borderColor = "var(--mantine-color-gray-3)",
  ...props
}: BorderedCardProps) {
  return (
    <Paper
      withBorder
      shadow="sm"
      radius="md"
      bg="white"
      {...props}
      style={{
        borderColor,
        ...style,
      }}
    >
      {children}
    </Paper>
  );
}
